var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.8 21.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,0H13.6A5,5,0,0,0,8.3,5.4V7.9H5.5a.43.43,0,0,0-.4.4V12a.43.43,0,0,0,.4.4H8.4v9.1a.43.43,0,0,0,.4.4h3.7a.43.43,0,0,0,.4-.4V12.4h3.4a.43.43,0,0,0,.4-.4V8.4a.35.35,0,0,0-.4-.4H13V5.8c0-1,.2-1.5,1.6-1.5h1.9a.43.43,0,0,0,.4-.4V.5A.46.46,0,0,0,16.5,0Z",
    transform: "translate(-5.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9bced0cc1de2612b6eb2fda071502cab.svg";
export { ForwardRef as ReactComponent };